import React from 'react';
import {List, ListItem, makeSelectable} from 'material-ui/List';
import Check from 'material-ui/svg-icons/navigation/check';
import {white, red} from 'material-ui/styles/colors';
import CircularProgress from 'material-ui/CircularProgress';

import styles from './styles/AccountSelectorStyles';
// rende la List selezionabile
let SelectableList = makeSelectable(List);

class AccountSelectorListView extends React.Component {
    constructor(props){
        super(props);

        this.handleNestedListToggle = this.handleNestedListToggle.bind(this);
        this.recursiveMenuItem = this.recursiveMenuItem.bind(this);
        this.handleRequestChange = this.handleRequestChange.bind(this);
    }

    handleNestedListToggle = (item) => {
      /*
        scateno ricerca sub account
      */
      this.props.handleLoadSubAccountsAccount(item.props.value);
    };

    handleRequestChange = (event, index) => {
      /*
        index = accountid
      */
      this.props.handleSelectAccountId(index);

    };

    recursiveMenuItem(list){

      if (!list) return null;
      if (list.length <= 0) return null;
      var selectList = [];

      for(var i=0;i<list.length;i++){
        var hasChild = true;
        var listItem = list[i];

        if (!listItem.children) hasChild = false;

        if (hasChild && listItem.children.length <= 0) hasChild = false;

        const checkIcon = <Check color={white} hoverColor={red} /> ;

        if(hasChild){
          /*
            ha subaccount quindi è già stato cliccato e ha dei nestedItems
            non metto evento di onNestedListToggle, sarebbe inutile
          */
          var childrens = this.recursiveMenuItem(listItem.children);
          selectList.push(<ListItem primaryText={listItem.title}
              key={i}
              style={styles.menuItem}
              value={listItem.value}
              initiallyOpen={listItem.isOpened}
              leftIcon={ this.props.selectedIndex === listItem.value ? checkIcon : null }
              nestedItems={childrens}
              primaryTogglesNestedList={true} />);

        }
        else if(listItem.hasBeenLoaded){
          /*
            è già stato cliccato e sono già stati cercati i suoi subaccount, tolgo evento di onNestedListToggle
          */
          selectList.push(<ListItem primaryText={listItem.title}
              key={i}
              value={listItem.value}
              style={styles.menuItem}
              initiallyOpen={listItem.isOpened}
              leftIcon={ this.props.selectedIndex === listItem.value ? checkIcon : null }
              primaryTogglesNestedList={true} />);
        }
        else if(!listItem.isLoading){
          /*
            non è mai stato cliccato e non è in fase di ricerca,
            quindi al prossimo click verrà fatta una ricerca sui
            suoi sub account
          */
         selectList.push(<ListItem primaryText={listItem.title}
              key={i}
              value={listItem.value}
              style={styles.menuItem}
              initiallyOpen={listItem.isOpened}
              primaryTogglesNestedList={true}
              onNestedListToggle={this.handleNestedListToggle} />);
        }
        else{
          /*
            in fase di caricamento dei subaccount!
            è stato cliccato, mostro uno spinner nell'icona sinistra
            e faccio in modo che non scateni altri click omettendo l'evento onNestedListToggle
          */
          selectList.push(<ListItem primaryText={listItem.title}
                            key={i}
                            value={listItem.value}
                            style={styles.menuItem}
                            initiallyOpen={listItem.isOpened}
                            leftIcon={<CircularProgress size={25} />}
                            primaryTogglesNestedList={true}
                          />);
        }

      }

      return selectList;
    }

    render() {
        const {accountList, selectedIndex} = this.props;

        return (
            <div>
              <SelectableList value={selectedIndex}
                onChange={this.handleRequestChange}
                selectedItemStyle={styles.selectedItem}
                >
                  {
                    this.recursiveMenuItem(accountList)
                  }
              </SelectableList>
            </div>
        );
    }
}

AccountSelectorListView.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

export default AccountSelectorListView;


// WEBPACK FOOTER //
// ./src/components/accountSelector/AccountSelectorListView.js